import { render, staticRenderFns } from "./ScoreGuessing.vue?vue&type=template&id=6106e6b9&scoped=true&"
import script from "./ScoreGuessing.vue?vue&type=script&lang=js&"
export * from "./ScoreGuessing.vue?vue&type=script&lang=js&"
import style0 from "./ScoreGuessing.vue?vue&type=style&index=0&id=6106e6b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6106e6b9",
  null
  
)

export default component.exports